export default function Separator(x) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
  })
    .format(x)
    .split(".")[0]
}
